import React, { useRef, useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { Formik, Form } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import { Checkbox, CircularProgress, FormControlLabel } from "@mui/material";
import { ActionSection, InputGroup, ScrollableContent, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "../SinglePropSelectModal";

const RentingStayRulesModal = ({ onClose, settingsData, editRentingDetailMutate, editRentingDetailLoading, property, propertyList, propertyParam, rentingDetailsMutate, isLoading,
  isDataLoaded }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showPropertyModal, setShowPropertyModal] = useState(false)
  const [height, setHeight] = useState(window.innerHeight);
  const [selectedProperty, setSelectedProperty] = useState();
  const [selectedPropertyId, setSelectedPropertyId] = useState();
  const [replicateToAll, setReplicateToAll] = useState(0);
  const [isPropertyChanging, setIsPropertyChanging] = useState(false);

  useEffect(() => {
    if (propertyList.length > 1) {
      setSelectedProperty(propertyList[1]);
    }
  }, [propertyList]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (propertyParam) {
      //setSelectedProperty(propertyParam);
      setSelectedPropertyId(propertyParam);
    }
  }, [propertyParam]);

  const initialValues = {
    rent: settingsData?.rent || 0,
    security: settingsData?.security || "0",
    lockInPeriod: settingsData?.lockInPeriod || "",
    noticePeriod: settingsData?.noticePeriod || "",
    agreementDuration: settingsData?.agreementDuration || "",
    rentalCycle: settingsData?.rentalCycle || "",
  };

  const rentalCycle = [
    { label: "1st to 1st", value: "01" },
    { label: "15th to 15th", value: "15" },
    { label: "Move-In Date", value: "00" },
  ];

  const filteredProperties = propertyList?.filter(prop => prop.id !== 0) || [];

  const handlePropertyChange = (event) => {
    const newPropertyId = event.target.value;
    setSelectedProperty(newPropertyId);
    setIsPropertyChanging(true);
    if (newPropertyId && rentingDetailsMutate) {
      // rentingDetailsMutate(newPropertyId);
      rentingDetailsMutate(newPropertyId, {
        onSettled: () => {
          setIsPropertyChanging(false);
        }
      });
    }
  };

  const handleReplicateChange = (event) => {
    setReplicateToAll(event.target.checked ? 1 : 0);
  };
  const handleSubmit = (values) => {
    if (!values.security) {
      toast.error("Security is required");
      return;
    }
    if (!values.rentalCycle) {
      toast.error("Rental Cycle is required");
      return;
    }
    if (!values.lockInPeriod) {
      toast.error("LockInPeriod is required");
      return;
    }
    if (!values.noticePeriod) {
      toast.error("Notice Period is required");
      return;
    }
    if (!values.agreementDuration) {
      toast.error("Agreement Duration is required");
      return;
    }

    const submitData = {
      ...values,
      replicate: replicateToAll,
      selectedPropertyId: selectedPropertyId
    };
    editRentingDetailMutate(submitData);
  };

  const handleSelectedProperty = (selectedOption) => {
    setSelectedProperty(selectedOption);
    const newPropertyId = selectedOption.id;
    setSelectedPropertyId(newPropertyId);
    setIsPropertyChanging(true);
    if (newPropertyId && rentingDetailsMutate) {
      // rentingDetailsMutate(newPropertyId);
      rentingDetailsMutate(newPropertyId, {
        onSettled: () => {
          setIsPropertyChanging(false);
        }
      });
    }
    // if (formikRef.current) {
    //   formikRef.current.setFieldValue("property", selectedOption.id)
    // }
  }

  return (
    <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>

      <Header>
        <HeaderTitle> {isEditing ? "Edit Agreement Rules" : "Agreement Rules"}</HeaderTitle>
        <CloseButton onClick={onClose}>
          <MdClose color="white" size={24} />
        </CloseButton>
      </Header>

      {isLoading || !isDataLoaded ? (
        <div className="flex items-center justify-center h-full">
          <CircularProgress />

        </div>
      ) : (
        <>
          <ContentContainer>
            <div className={isEditing ? "px-6 py-0" : "px-6 py-6"} >
              <Section>
                {!isEditing && property?.id === 0 && (
                  <PropertySection>
                    <CategoryCard
                      title="Property"
                      selectedCategory={selectedProperty}
                      onClick={() => setShowPropertyModal(true)}
                    />
                    {/* <InputGroup>
                      <Select
                        value={selectedProperty}
                        onChange={handlePropertyChange}
                        className="px-2 w-full"
                        style={{ height: "46px" }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select a property
                        </MenuItem>
                        {filteredProperties.map((propertyItem) => (
                          <MenuItem key={propertyItem.id} value={propertyItem.id}>
                            {propertyItem.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </InputGroup> */}
                  </PropertySection>)}

                {isEditing ? (
                  <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                  >
                    {({ values, handleChange, errors, touched }) => (
                      <Form >
                        <ScrollableContent className="max-h-[calc(100vh-140px)]">
                          <Wrapper>
                            <InputGroup>
                              <Label>Security (₹)</Label>
                              <Input
                                id="security"
                                type="number"
                                name="security"
                                value={values.security}
                                onChange={handleChange}
                              />
                              {touched.security && errors.security && <Error>{errors.security}</Error>}
                            </InputGroup>
                            <InputGroup>
                              <Label>Lock-in Period (Months)</Label>
                              <Select
                                name="lockInPeriod"
                                value={values.lockInPeriod}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(12).keys()].map((num) => {
                                  const value = (num + 1) * 1;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.lockInPeriod && errors.lockInPeriod && (
                                <Error>{errors.lockInPeriod}</Error>
                              )}
                            </InputGroup>
                            <InputGroup>
                              <Label>Notice Period (Months)</Label>
                              <Select
                                name="noticePeriod"
                                value={values.noticePeriod}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(24).keys()].map((num) => {
                                  const value = (num + 1) * 0.5;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.noticePeriod && errors.noticePeriod && (
                                <Error>{errors.noticePeriod}</Error>
                              )}
                            </InputGroup>
                            <InputGroup>
                              <Label>Agreement Duration (Months)</Label>
                              <Select
                                name="agreementDuration"
                                value={values.agreementDuration}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(12).keys()].map((num) => {
                                  const value = (num + 1) * 1;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.agreementDuration && errors.agreementDuration && (
                                <Error>{errors.agreementDuration}</Error>
                              )}
                            </InputGroup>
                            {/* </Section> */}
                            <InputGroup>
                              <Label>Rental Cycle (Days)</Label>
                              <Select
                                name="rentalCycle"
                                value={values.rentalCycle}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {rentalCycle.map((mode) => (
                                  <MenuItem key={mode.value} value={mode.value}>
                                    {mode.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.rentalCycle && errors.rentalCycle && (
                                <Error>{errors.rentalCycle}</Error>
                              )}
                            </InputGroup>
                            {property?.id === 0 && (
                              <InputGroup>
                                <FormControlLabel
                                  className="text-gray-500 text-sm"
                                  control={
                                    <Checkbox
                                      checked={replicateToAll === 1}
                                      onChange={handleReplicateChange}
                                      name="replicateToAll"
                                      color="primary"
                                    />
                                  }
                                  label="Replicate these rules to all properties"
                                />
                              </InputGroup>)}

                          </Wrapper>
                        </ScrollableContent>
                        <ActionSection $isEditing={isEditing}>
                          <SideCancelBtn
                            type="button"
                            $isEditing={isEditing}
                            onClick={() => setIsEditing(false)}
                          >
                            Back
                          </SideCancelBtn>
                          <SubmitBtn $isEditing={isEditing} type="submit" disable={editRentingDetailLoading}>
                            {editRentingDetailLoading ? "Updating..." : "Update"}
                          </SubmitBtn>
                        </ActionSection>


                      </Form>
                    )}
                  </Formik>
                ) : (
                  <>
                    {isPropertyChanging ? (
                      <div className="flex items-center justify-center h-full pt-10">
                        <CircularProgress />
                      </div>) : (
                      <SettingsGrid>
                        <SettingCard >
                          <SectionTitle>Rent & Agreement Details</SectionTitle>
                          <SettingContent className="px-5 py-3">

                            <Label>Security</Label>
                            <Value>{"₹" + settingsData?.security || 0}</Value>
                          </SettingContent>
                          <SettingContent className="px-5 pb-3 pt-0">
                            <Label>Lock-in Period</Label>
                            <Value>{settingsData.lockInPeriod + " Month"}</Value>
                          </SettingContent>
                          <SettingContent className="px-5 pb-3 pt-0">
                            <Label>Notice Period</Label>
                            <Value>{settingsData.noticePeriod + " Month"}</Value>
                          </SettingContent>
                          <SettingContent className="px-5 pb-3 pt-0">
                            <Label>Agreement Duration</Label>
                            <Value>{settingsData.agreementDuration + " Month"}</Value>
                          </SettingContent >
                          <SettingContent className="px-5 pb-3 pt-0">
                            <Label>Rent Addition Cycle</Label>
                            <Value>{settingsData?.rentalCycle == '00' ? 'Move-In Date' : settingsData?.rentalCycle + " to " + settingsData.rentalCycle}</Value>
                          </SettingContent>
                        </SettingCard>
                      </SettingsGrid>)}
                    <ActionSection $isEditing={isEditing}>
                      <SideCancelBtn
                        type="button"
                        onClick={onClose}
                      >
                        Cancel
                      </SideCancelBtn>
                      <SubmitBtn $isEditing={isEditing}
                        onClick={() => setIsEditing(true)}>
                        Edit
                      </SubmitBtn>
                    </ActionSection>
                  </>

                )}
              </Section>
            </div>
            <SinglePropSelectModal
              isOpen={showPropertyModal}
              onClose={() => setShowPropertyModal(false)}
              onSelect={handleSelectedProperty}
              options={filteredProperties}
              selectedProperty={selectedProperty}
            />
          </ContentContainer>
        </>
      )}
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] p-4`;
const HeaderTitle = tw.h1`text-white text-lg font-medium`;
const CloseButton = tw.button``;
const ContentContainer = tw.div`flex-1 overflow-y-auto`;
// const ContentWrapper = tw.div`p-6`;
const ContentWrapper = tw.div`${({ isEditing }) =>
  isEditing ? "px-6 py-0" : "px-6 py-6"
  }`;
const Section = tw.div`space-y-6`;
const PropertySection = tw.div`bg-gray-50 rounded-xl p-4 border border-gray-200 mb-4`;
const SettingsGrid = tw.div`space-y-4 `;
const SettingCard = tw.div`bg-gray-50 rounded-xl border border-gray-200 hover:shadow-md transition-shadow duration-200`;
const SettingContent = tw.div`flex items-start justify-between space-x-6 p-5`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Value = tw.span`text-gray-800 font-medium`;
const Input = tw.input`border border-gray-300 rounded h-10 px-2 py-1 focus:ring-1 focus:ring-primary-color focus:border-primary-color focus:outline-none`;
const Error = tw.p`text-rose-600 text-sm`;
const SectionTitle = tw.h2`text-md font-semibold text-gray-800 mt-4 mx-4`;
export default RentingStayRulesModal;